import {Component, Input, OnInit} from '@angular/core';
import {API, DeviceConfigurationTokenDTO, DeviceFullDTO} from 'src/app/services/api/api';
import {ModalNavigationComponent} from 'src/app/services/gui/modal/modal-navigation-component';
import {ModalNavigationService} from 'src/app/services/gui/modal/modal-navigation.service';

@Component({
  selector: 'sb-pairing-result',
  templateUrl: './sb-pairing-result.component.html',
  styleUrls: ['./sb-pairing-result.component.scss'],
  standalone: false,
})
export class SbPairingResultComponent implements OnInit, ModalNavigationComponent {
  isInModalContext: boolean;

  mode: string;
  success: boolean;
  message: string;
  configuration: DeviceConfigurationTokenDTO;

  @Input()
  device: DeviceFullDTO;

  constructor(
    private api: API,
    private modalNavigation: ModalNavigationService
  ) {}

  ngOnInit() {
    if (this.isInModalContext) {
      const data = this.modalNavigation.getCurrentNavigation().data;
      this.mode = data.mode;
      this.success = data.success;
      this.message = data.message;
      this.configuration = data.configuration;
      this.device = data.device;
    }
  }

  getConfigurationJSON() {
    return JSON.stringify(this.configuration, null, 2);
  }
}
